module.exports = __webpack_public_path__ + "static/media/mc-chicken.28c1a09c.png";